export default "__VITE_ASSET__Bosfbq9I__"